import { render, staticRenderFns } from "./TableTreeView.vue?vue&type=template&id=1884d28c&scoped=true&"
import script from "./TableTreeView.vue?vue&type=script&lang=js&"
export * from "./TableTreeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1884d28c",
  null
  
)

export default component.exports